<template>
    <div>
        <!-- item -->
        <div
            v-for="item in lists"
            :key="item.id"
            class="border-t border-gray-400 list"
        >
            <div
                class="flex flex-wrap justify-between w-full py-4"
                @click="item.active = !item.active"
            >
                <div class="flex-1 overflow-hidden">
                    <div class="text-[16px] text-black px-5">
                        Q: {{ item.question }}
                    </div>
                    <div
                        class="transition-all text-[16px] text-black h-0 overflow-hidden"
                        :class="{ 'h-auto mt-5': item.active}"
                    >
                        <div class="px-5">
                            A:
                        </div>
                        <div class="p-5 xl:py-3 px-4">
                            <div
                                class="border border-blue-700 rounded-lg p-6 break-all html-content text-justify"
                                v-html="cleanHtml(item.answer)"
                            >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-6 mt-1">
                    <component
                        :is="item.active ? 'IconChevronUp' : 'IconChevronDown'"
                        class="w-5 h-5 text-black"
                    />
                </div>
            </div>
        </div>
        <!-- / item -->
    </div>
</template>

<script>
import IconChevronUp from '@/components/icons/ChevronUp';
import IconChevronDown from '@/components/icons/ChevronDown';
/**
 * 熱門問題
 */
export default {
    name: 'HotFaq',
    components: {IconChevronDown, IconChevronUp},
    props: {
        /**
         * 回傳 API-InsCombination 中 QuestionAndAnswer 熱門問題資料
         */
        lists: {
            type: Array,
            default: () => { return []; }
        }
    },
    methods: {
        /**
         * 使用 DOMPurify 將傳入的 html 進行字串的清理，防止 XSS 攻擊
         *
         * @param {String} html 由 API-InsCombination 中 QuestionAndAnswe 回傳的熱門問題的 html 格式
         * @returns {String} 回傳處理過的 HTML 字串
         * @public
         */
        cleanHtml(html) {
            return DOMPurify.sanitize(html);
        },
    }
};
</script>
<style scoped>
.list:first-child  {
    @apply border-t-0;
}
</style>